import { useEffect } from "react";
import { PhotoDisplayHandler } from "components";
import { AppDispatch, RootState } from "store";
import { useEffectDeviceAndOrientation } from "utils/hooks";
import { useDispatch, useSelector } from "react-redux";
import { fetchLargeBaners } from "store/baners/baners.slice";
import "./SpecialBaners.scss";

const SpecialBaners = () => {
  const [device, orientation] = useEffectDeviceAndOrientation();
  const { list, is_fetch } = useSelector(
    (store: RootState) => store.baners.large
  );
  const dispatch: (arg: any) => AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchLargeBaners());
  }, [dispatch]);

  return (
    <div className="Special-Baners-Box">
      {is_fetch && (
        <a
          href={list[0].url}
          target="_blank"
          title={`Vidi detaljno ${list[0].baner_name}`}
          rel="noopener noreferrer"
        >
          <PhotoDisplayHandler
            img_name={list[0].image}
            calculate={false}
            img_class_name=""
            img_alt={list[0].baner_name}
            width="100%"
            height="auto"
          />
        </a>
      )}
    </div>
  );
};
export default SpecialBaners;
